import React from "react";

import TabList, { TabListProps } from "@mui/lab/TabList";
import MuiTabPanel from "@mui/lab/TabPanel";
import { styled } from "@mui/material";
import MuiTab from "@mui/material/Tab";

const StyledTabList = styled(TabList)(({ theme }) => ({
    minHeight: theme.spacing(4),
    borderBottom: `1px solid ${theme.palette.emteria.border.primary}`,
    "& .MuiTabs-indicator": {
        backgroundColor: theme.palette.emteria.link,
    },
}));

/**
 * The tab bar of a dialog: spans the full dialog width, with a separator underneath. Use inside a `TabContext`, with
 * `ModalTab` children and `ModalTabPanel`s for the content.
 */
export const ModalTabList = (props: TabListProps) => <StyledTabList variant="fullWidth" {...props} />;

/**
 * A single tab of a `ModalTabList`.
 */
export const ModalTab = styled(MuiTab)(({ theme }) => ({
    color: theme.palette.text.secondary,
    minHeight: theme.spacing(4),
    "&.Mui-selected": {
        color: theme.palette.emteria.link,
    },
}));

/**
 * The content of one `ModalTab`, without padding of its own so the dialog's body spacing applies.
 */
export const ModalTabPanel = styled(MuiTabPanel)({
    padding: 0,
});
